"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTabs = void 0;
var react_1 = require("react");
var index_1 = require("./index");
function useTabs() {
    return react_1.useContext(index_1.TabsContext);
}
exports.useTabs = useTabs;
//# sourceMappingURL=hooks.js.map